/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Save_Changes_TitleInputs */

const en_knp_lookup_save_changes_title = /** @type {(inputs: Knp_Lookup_Save_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Changes`)
};

const fr_knp_lookup_save_changes_title = /** @type {(inputs: Knp_Lookup_Save_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer les modifications`)
};

const de_knp_lookup_save_changes_title = /** @type {(inputs: Knp_Lookup_Save_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen speichern`)
};

const it_knp_lookup_save_changes_title = /** @type {(inputs: Knp_Lookup_Save_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva modifiche`)
};

const ru_knp_lookup_save_changes_title = /** @type {(inputs: Knp_Lookup_Save_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить изменения`)
};

const es_knp_lookup_save_changes_title = /** @type {(inputs: Knp_Lookup_Save_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar cambios`)
};

const zh_cn2_knp_lookup_save_changes_title = /** @type {(inputs: Knp_Lookup_Save_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存更改`)
};

const ja_knp_lookup_save_changes_title = /** @type {(inputs: Knp_Lookup_Save_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更を保存`)
};

const hi_knp_lookup_save_changes_title = /** @type {(inputs: Knp_Lookup_Save_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिवर्तनों को सुरक्षित करें`)
};

const pt_pt2_knp_lookup_save_changes_title = /** @type {(inputs: Knp_Lookup_Save_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar alterações`)
};

/**
* | output |
* | --- |
* | "Save Changes" |
*
* @param {Knp_Lookup_Save_Changes_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_save_changes_title = /** @type {((inputs?: Knp_Lookup_Save_Changes_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Save_Changes_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_save_changes_title(inputs)
	if (locale === "de") return de_knp_lookup_save_changes_title(inputs)
	if (locale === "it") return it_knp_lookup_save_changes_title(inputs)
	if (locale === "ru") return ru_knp_lookup_save_changes_title(inputs)
	if (locale === "es") return es_knp_lookup_save_changes_title(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_save_changes_title(inputs)
	if (locale === "ja") return ja_knp_lookup_save_changes_title(inputs)
	if (locale === "hi") return hi_knp_lookup_save_changes_title(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_save_changes_title(inputs)
	return en_knp_lookup_save_changes_title(inputs)
});